// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
const noop = (...args: any) => {};
export default noop;
